module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.626 16.548l-8.724 5.318c-.498.304-.902.072-.902-.52V10.652c0-.592.404-.822.902-.52l8.724 5.316c.498.304.498.798 0 1.1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-circle-1.js
// module id = 1385
// module chunks = 14